import { createSlice } from '@reduxjs/toolkit';

import { AppState } from '../store';
export interface IUserState {
  currentUserAddr: string;
  prevUserAddr: string;
  impostorAddress: string;
}

export const initialState: IUserState = {
  currentUserAddr: '',
  prevUserAddr: '',
  impostorAddress: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUserAddr: (state, { payload: { account } }) => {
      account = account?.toLowerCase();
      if (state.prevUserAddr === '') {
        state.prevUserAddr = account;
      }
      state.currentUserAddr = account;
    },
    setPrevUserAddr: (state, { payload: { account } }) => {
      account = account?.toLowerCase();
      state.prevUserAddr = account || state.currentUserAddr;
    },
    setImpostorAddress: (state, { payload: { account } }) => {
      account = account?.toLowerCase();
      state.impostorAddress = account;
    },
  },
});

export const { setCurrentUserAddr, setPrevUserAddr, setImpostorAddress } = userSlice.actions;

export const selectUserState = (state: AppState): IUserState => state.user;
export const selectCurrentUserAddr = (state: AppState): string => state.user.currentUserAddr;
export const selectImpostorAddress = (state: AppState): string => state.user.impostorAddress;

export default userSlice.reducer;
